import { RACE_GRADIENTS } from '../../constants/raceGradients';

/**
 * SF-122 Component 4: race-styled crest badge, reusing the exact gradient values from
 * `RACE_GRADIENTS` (SF-86, extracted to `constants/raceGradients.ts`). No race portrait artwork
 * exists anywhere in the codebase today — the monogram glyph is an explicit placeholder,
 * swappable later without a component API change.
 */
interface RaceCrestProps {
  race: string;
  size?: number;
}

export function RaceCrest({ race, size = 40 }: RaceCrestProps) {
  const gradient = RACE_GRADIENTS[race] ?? RACE_GRADIENTS.HUMAN;
  const monogram = race ? race.charAt(0).toUpperCase() : '?';

  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: gradient,
        border: '1px solid rgba(255,255,255,0.12)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          fontSize: size * 0.42,
          fontWeight: 700,
          color: 'rgba(255,255,255,0.55)',
          fontFamily: 'serif',
        }}
      >
        {monogram}
      </span>
    </div>
  );
}
